import { StatusFilter } from '../../../ui/posts/FeedManagement/types';
import { PostStatus } from '../../../ui/posts/constants';

export const LIMIT = 20;

export const BORDER_RADIUS = { sm: 2 };

export const QUERY_PARAMETER_STATUS = 'status';

export const QUERY_PARAMETER_SOURCE = 'source';

export const QUERY_PARAMETER_PERIOD = 'period';

export const QUERY_PARAMETER_DATE_FROM = 'date_from';

export const QUERY_PARAMETER_DATE_TO = 'date_to';

export const STATUS_FILTER_MAPPING: Record<string, PostStatus[]> = {
    [StatusFilter.ALL]: [
        PostStatus.DRAFT,
        PostStatus.PUBLISHED,
        PostStatus.MODERATION,
        PostStatus.LIMITED,
        PostStatus.DECLINED,
    ],
    [StatusFilter.MODERATION]: [PostStatus.MODERATION],
    [StatusFilter.DECLINED]: [PostStatus.DECLINED],
    [StatusFilter.DRAFTS]: [PostStatus.DRAFT],
    [StatusFilter.WITHOUT_DRAFTS]: [
        PostStatus.PUBLISHED,
        PostStatus.MODERATION,
        PostStatus.LIMITED,
        PostStatus.DECLINED,
    ],
};

export const BULK_CONFIRM_MESSAGE_MAPPING: Partial<Record<PostStatus, string>> = {
    [PostStatus.DELETED]: 'Выбранные посты будут безвозвратно удалены',
    [PostStatus.MODERATION]: 'Выбранные посты будут отправлены на модерацию',
};

export const BULK_SUCCESS_MESSAGE_MAPPING: Partial<Record<PostStatus, string>> = {
    [PostStatus.DELETED]: 'Выбранные посты удалены',
    [PostStatus.MODERATION]: 'Выбранные посты отправлены на модерацию',
};
